import _ from "underscore";
import UsersSelectorTree from "./UsersSelectorTree";
import HierarchySelectorUtil from "../../controls/selectorControls/hierarchy_selector_util";

export default function UserGroupSelectorTree(rootNode, emptyMessageBuilder, collapsedNodeIds, getGroupIdFromUserCallback)
{
    UsersSelectorTree.call( this, rootNode, emptyMessageBuilder, collapsedNodeIds );
    this.getGroupIdFromUserCallback = getGroupIdFromUserCallback;
}

UserGroupSelectorTree.prototype = _.create(UsersSelectorTree.prototype);

UserGroupSelectorTree.prototype.isSelectionChanged = function()
{
    return HierarchySelectorUtil.isSelectionChanged(this);
};



// WEBPACK FOOTER //
// ./web/js/hierarchySelector/userSelector/UserGroupSelectorTree.js